import React, {
    useContext,
} from 'react';
import { useMutation } from '@tanstack/react-query';

import { NotificationContext, handleError } from "../router"

import * as QUERIES from "../query-functions";

export default function LogoutButton() {

    const {notification, setNotification} = useContext(NotificationContext);

    const logOut = useMutation({
        mutationFn: () => QUERIES.logOut(),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            window.location.reload();
        },
    })

    return (
        <button type="button" className='btn btn--logout' onClick={() => logOut.mutateAsync()}>Logout</button>
    );
}